import { assertWorkspaceActive } from '../data/workspace'

let pending: Promise<unknown> = Promise.resolve()
/** Cleanup follows previously-issued native commands; stale queued writers are
 * rejected before invocation, so they cannot repopulate a cleared widget/schedule. */
export function queueWorkspaceNativeMutation<T>(operation: () => Promise<T>, cleanup = false): Promise<T> {
  const result = pending.catch(() => undefined).then(() => {
    if (!cleanup) assertWorkspaceActive()
    return operation()
  })
  pending = result
  return result
}
